import { useEffect, useState } from "react";
import { useAuthentication } from "../context/Authentication";
import { useEstablecimiento } from "../context/Establecimiento";
import { listarTramites } from "../api/Tramite";
import { useTranslation } from "react-i18next";
import { TRAMITES_ENDPOINT } from "../utils/api";
import Grid from "../components/layout/Grid";
import Row from "../components/layout/Row";
import Col from "../components/layout/Col";
import LinkButton from "../components/controls/LinkButton";
import DownloadIcon from "../components/icon/DownloadIcon";
import EyeIcon from "../components/icon/EyeIcon";
import PencilSquareIcon from "../components/icon/PencilSquareIcon";
import Pagination from "../components/controls/Pagination";
import { EstadoTramite } from "../utils/enums";

const REGISTROS_POR_PAGINA = 10;

export function ListadoTramitesPage({ ...props }) {
  const { establecimiento } = useEstablecimiento();
  const { t } = useTranslation();
  const { token } = useAuthentication();
  const [pagina, setPagina] = useState(1);
  const [paginas, setPaginas] = useState(0);
  const [total, setTotal] = useState();
  const [tramites, setTramites] = useState([]);
  const onPageChange = (event) => {
    event.preventDefault();
    setPagina(event.target.value);
  };
  useEffect(() => {
    listarTramites(
      {
        CURT: establecimiento.CURT,
        estados: [
          EstadoTramite.APROBADO,
          EstadoTramite.PRESENTADO,
          EstadoTramite.FINALIZADO,
          EstadoTramite.PENDIENTE,
          EstadoTramite.INICIADO,
        ],
        max: REGISTROS_POR_PAGINA,
        offset: (pagina - 1) * REGISTROS_POR_PAGINA,
      },
      token,
    ).then((respuesta) => {
      setPagina(respuesta.desplazamiento + 1);
      setPaginas(respuesta.paginas);
      setTramites(respuesta.tramites);
      setTotal(respuesta.total);
    });
  }, [establecimiento, token, pagina]);
  return (
    <Grid id="listadoTramitesPage">
      <Row>
        <h3>{t("listadoTramitesPage.titulo")}</h3>
      </Row>
      <Row>
        <Col>
          <Pagination page={pagina} pages={paginas} onChange={onPageChange} />
          <table className="table table-bordered">
            <thead>
              <tr className="text-primary">
                <th>{t("tramite.numero")}</th>
                <th>{t("tramite.tipo")}</th>
                <th>{t("tramite.estado")}</th>
                <th>{t("tramite.fechaEstado")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tramites?.map((tramite) => (
                <tr>
                  <td>{tramite.numero}</td>
                  <td>{tramite.tipo.nombre}</td>
                  <td>{tramite.estado.nombre}</td>
                  <td>{new Date(tramite.fechaEstado).toLocaleDateString()}</td>
                  <td>
                    {[EstadoTramite.PRESENTADO, EstadoTramite.APROBADO].indexOf(
                      tramite.estado.codigo,
                    ) >= 0 && (
                      <>
                        <LinkButton
                          sm
                          style={{ margin: 0, fontSize: "16px" }}
                          href={`${TRAMITES_ENDPOINT}/${tramite.numero}.pdf?token=${token}`}
                          download={`${tramite.numero}.pdf`}
                        >
                          <DownloadIcon />
                        </LinkButton>
                        <LinkButton
                          sm
                          style={{ margin: 0, fontSize: "16px" }}
                          href={`/tramite/${tramite.numero}`}
                        >
                          <EyeIcon />
                        </LinkButton>
                      </>
                    )}
                    {[
                      EstadoTramite.INICIADO,
                      EstadoTramite.PENDIENTE,
                      EstadoTramite.FINALIZADO,
                    ].indexOf(tramite.estado.codigo) >= 0 && (
                      <LinkButton
                        sm
                        style={{ margin: 0, fontSize: "16px" }}
                        href={`/tramite/${tramite.numero}`}
                      >
                        <PencilSquareIcon />
                      </LinkButton>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" style={{ textAlign: "right" }}>
                  <strong className="text-muted">
                    <small>
                      {t("listadoTramitesPage.totalTramites")}&nbsp;{total}
                      ,&nbsp;
                      {t("listadoTramitesPage.totalPendientes")}&nbsp;
                      {
                        tramites.filter(
                          (tramite) =>
                            [
                              EstadoTramite.PENDIENTE,
                              EstadoTramite.INICIADO,
                              EstadoTramite.FINALIZADO,
                            ].indexOf(tramite.estado.codigo) >= 0,
                        ).length
                      }
                      ,&nbsp;
                      {t("listadoTramitesPage.totalPresentados")}&nbsp;
                      {
                        tramites.filter(
                          (tramite) =>
                            tramite.estado.codigo === EstadoTramite.PRESENTADO,
                        ).length
                      }
                      ,&nbsp;
                      {t("listadoTramitesPage.totalProcesados")}&nbsp;
                      {
                        tramites.filter(
                          (tramite) =>
                            tramite.estado.codigo === EstadoTramite.APROBADO,
                        ).length
                      }
                    </small>
                  </strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </Col>
      </Row>
    </Grid>
  );
}
